import React, {Component} from 'react'
import {Card, Container} from "react-bootstrap";
import Image from "react-bootstrap/Image";

/**
 * The abstract component of the dashboard cards.
 * @deprecated Replaced with CardBase.
 */
class MainCard extends Component {
    /**
     * Render the card component.
     * @returns {React.ReactNode} The card component.
     */
    render = () => {
        return (
            <Card className="dashboard-card">
                <Card.Header className="card-header"> {this.renderHeader()} </Card.Header>
                <Card.Body className="card-body"> {this.renderBody()} </Card.Body>
                <Card.Footer className="card-footer">{this.renderFooter()}</Card.Footer>
            </Card>
        );
    };

    /**
     * Render the header component.
     * @returns {React.ReactNode} The header component of the card.
     */
    renderHeader = () => {
        const {title, subtitle} = this.props;

        return (
            <React.Fragment>
                <Card.Title className="title">{title}</Card.Title>
                <Card.Text className="subtitle"> {subtitle}</Card.Text>
            </React.Fragment>
        );
    };

    /**
     * Wrap items within container.
     * @returns {React.ReactNode} The wrapped items.
     */
    wrapItemsWithContainer = (items) => {
        return (
            <Container fluid={true} className="dashboard-container">
                {items}
            </Container>
        )
    };

    /**
     * Render items from data prop.
     * @returns {React.ReactNode} The items.
     */
    renderItemsFromData = () => {
    };

    /**
     * Render items from children nodes.
     * @returns {React.ReactNode} The items.
     */
    renderItemsFromChildren = () => {
        return this.props.children;
    };

    /**
     * Render the components within the body of the card.
     * @returns {React.ReactNode} The body of the card.
     */
    renderBody = () => {
        const {children} = this.props;
        if (children) {
            // If the component has data as children.
            return this.wrapItemsWithContainer(this.renderItemsFromChildren());
        } else {
            // If the component has data as object.
            return this.wrapItemsWithContainer(this.renderItemsFromData());
        }
    };

    /**
     * Render the footer component.
     * @returns {React.ReactNode} The footer component of the card.
     */
    renderFooter = () => {
        const {footerText, footerLink} = this.props;

        return (
            <Card.Link className="link" href={footerLink}>
                {footerText}
            </Card.Link>
        );
    };
}


class CardRowComponent extends Component {
    // TODO: Write Doc
}

class TeamsLogo extends CardRowComponent {
    // TODO: Write Doc

    render = () => {
        const {team1, team2, badge} = this.props;

        return (
            <div className="teams-logo-component left-side">
                <div className="team-logo-container">
                    <img className="team-logo" src={team1} alt="team-1"/>
                </div>
                <div className="vs-icon">VS</div>
                <div className="team-logo-container">
                    <img className="team-logo" src={team2} alt="team-2"/>
                </div>

                {badge && <div className="badge"/>}
            </div>
        );
    };
}

class RowInformation extends CardRowComponent {
    render = () => {
        const {title, subtitle, description} = this.props;
        return (
            <div className="row-information-component">
                <div className="info-container">
                    <span className="title"> {title} </span>
                    <span className="subtitle"> {subtitle} </span>
                    <span className="description"> {description} </span>
                </div>
            </div>
        );
    };
}

class DateTimeDetails extends CardRowComponent {
    render = () => {
        const {datetime, datetimeType} = this.props;
        // TODO: Convert datetime to date/ time according to server response.
        const date = 'Today';
        const time = '12:40 PM';
        return (
            <div className="date-time-details-component">
                <div className="datetime-details right-side">
                    <div className="day">{date}</div>
                    <div className="time">{time}</div>
                    <div className="type"> {datetimeType}</div>
                </div>
            </div>
        );
    };

    static defaultProps = {
        datetimeType: "Standard Time",
    };
}

class Avatar extends CardRowComponent {
    render = () => {
        const {source} = this.props;
        return (
            <div className="player-avatar-container left-side">
                <Image className="player-avatar rounded-circle" src={source}/>
            </div>
        );
    };

    static defaultProps = {
        datetimeType: "Standard Time",
    };
}


export default MainCard;
export {TeamsLogo, Avatar, RowInformation, DateTimeDetails};
